import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, SelectItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { FileUtility } from '../../../shared/utility/file.utility';
import { User } from "../../../actiontracker/model/user.model";
import { ActiontrackerService } from '../../../actiontracker/services/actiontracker.service';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { Login } from '../../../observation/model/login.model';
import { SearchText } from '../../../observation/model/searchTexts.model';
import { ObservationService } from '../../../observation/services/observation.service';
import { IndependentPermissions } from '../../../shared/models/IndependentPermissions.model';
import { UserPermissionParameters } from '../../../shared/models/user.model';
import { NotificationsService } from '../../../shared/services/notification.service';
import { IncidentRating } from '../../model/incident-rating';
import { DashboardFilter } from './../../../shared/models/dashboardFilter.model';
import { BaseService } from './../../../shared/services/base.service';
import { CommonService } from './../../../shared/services/common.service';
import { ConstantsService } from './../../../shared/services/constants.service';
import { IncidentRequestGet } from './../../model/incidentRequestPost.model';
import { IncidentConstantsService } from './../../services/incident-constants-service';
import { IncidentService } from './../../services/incident.service';
import { ActivatedRoute } from "@angular/router";
import { coerceNumberProperty } from "@angular/cdk/coercion";


@Component({
  selector: 'ara-incident-dashboard',
  templateUrl: './incident-dashboard.component.html',
  styleUrls: ['./incident-dashboard.component.css']
})
export class IncidentDashboardComponent implements OnInit {
  @ViewChild('cm') contextMenu: ContextMenu;
  loggedInUserJSON: any;
  statusList: any[];
  statusId: number[] = [];
  incidentFilterData: DashboardFilter;
  incidentRequestData: IncidentRequestGet[];
  // set variable for pagination
  rowCount: number;
  pageSize: number = 1;
  itemPerPage: number = 50;
  hideFilter: boolean;
  hideSort: boolean;
  filterList: string[];
  defaultStatus: string;
  routesFlag: { routeName: string, routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string, routeURL: string; isClickable: boolean; }[];
  incidentId: number;
  //incidentTypedata: any[];
  actionType: string;
  actionTypeId: number;
  showcaseOwner: boolean = false;
  incidentFromDate: Date = null;
  incidentToDate: Date = null;
  isshowBackOffice: boolean = false;
  searchModified: boolean = false;
  actionTypeFilter: any;
  incidentPermission: IndependentPermissions;
  userPermissions: UserPermissionParameters;
  selectedReporting: string[] = [];
  permissions: any = [];
  incidentSourceIdsDetails: any = [];
  incidentType: any[] = [];
  currentSourceRowCount: number;
  reportedToList: any[] = [];
  incidentTypeList: any[];
  checked: any;
  currentDate = new Date();
  caseOwner: User;
  searchTexts: SearchText;
  userResults: any[];
  ratings: SelectItem[] = [];
  locationList: SelectItem[];
  selectedLocations: any = [];
  selectedReportedTo: any[] = [];
  isHighPotential: string = 'true';
  searchText: string = '';
  contextItems: MenuItem[] = [];
  selectedIncident: number;
  row: HTMLElement;
  window = window;
  isIncidentsChecked: boolean = true;
  noRecordsMsg: string = 'No Records Found';
  highPotentials: any[] = [];
  selectedPotential: any = [];
  selectedUnit: any[];
  unitList: any[];
  currentId: number;
  selectedincidentTypeId: string[] = [];
  incidentRating: IncidentRating = new IncidentRating();
  disableExport: boolean = false;
  RedirectFromDashboard : number = 0;


  constructor(private baseService: BaseService,
    private commonService: CommonService,
    private incidentService: IncidentService,
    private actionTrackerService: ActiontrackerService,
    private observationService: ObservationService,
    private router: Router,
    private notificationsService: NotificationsService,
    private masterscreenService: MasterscreenService,
    private translate: TranslateService,
    private route: ActivatedRoute) {
    this.incidentFilterData = new DashboardFilter();
    this.highPotentials.push({
      'label': 'Yes',
      'value': 1
    });
    this.highPotentials.push({
      'label': 'No',
      'value': 0
    });
    this.selectedPotential.push(0);
    this.selectedPotential.push(1);
    this.reportedToList.push({ label: 'Management', value: "0", checked: true });
    this.reportedToList.push({ label: 'Client', value: "1", checked: true });
    this.reportedToList.push({ label: 'MECA', value: "2", checked: true });
    this.reportedToList.push({ label: 'Ministry Of Manpower', value: "3", checked: true });
    this.reportedToList.push({ label: 'ROP', value: "4", checked: true });
    this.selectedReportedTo.push(0);
    this.selectedReportedTo.push(1);
    this.selectedReportedTo.push(2);
    this.selectedReportedTo.push(3);
    this.selectedReportedTo.push(4);
    this.ratings.push({ label: 'Select', value: -1 });
    this.ratings.push({ label: '0', value: 0 });
    this.ratings.push({ label: '1', value: 1 });
    this.ratings.push({ label: '2', value: 2 });
    this.ratings.push({ label: '3', value: 3 });
  }

  //#region - get status List by process name
  getStatusListByProcessName() {
    this.baseService.showRootLoader = true;
    // Create model for ProcessName
    const request = {
      Model: {
        ProcessName: ConstantsService.ProcessName.Incident
      }
    };
    // Get Status List by ProcessName
    this.commonService.getStatusListByProcessName(request, this.callbackMethodForGetStatusListByProcessName.bind(this));
  }

  // call back method of get status list by processName
  callbackMethodForGetStatusListByProcessName(response) {
    this.baseService.showRootLoader = false;
    // Set list of status
    this.statusList = [];
    response.forEach(status => {
      if (status.StatusName === IncidentConstantsService.IncidentStatus.New ||
        status.StatusName === IncidentConstantsService.IncidentStatus.Closed ||
        status.StatusName === IncidentConstantsService.IncidentStatus.Draft) {
        this.statusList.push({
          label: status.StatusName,
          value: status.StatusId,
          checked: true
        });
        this.statusId.push(status.StatusId);
      }
    });
    this.incidentPermission = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    if (!this.incidentPermission.INC_Add && !this.incidentPermission.INC_Add_Unit && !this.incidentPermission.INC_Admin && !this.incidentPermission.INC_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === IncidentConstantsService.RouteName.ReportIncident) {
          this.routesFlag.splice(index, 1);
        }
      }
    }
    if (  this.incidentPermission.SUPER_Admin) {
      response.forEach(status => {
        if (status.StatusName === IncidentConstantsService.IncidentStatus.Cancelled ||
          status.StatusName === IncidentConstantsService.IncidentStatus.Deleted) {
          this.statusList.push({
            label: status.StatusName,
            value: status.StatusId,
            checked: true
          });
          this.statusId.push(status.StatusId);
        }
      });
    }
    // get the Id of Pending Status
    this.getLocations();
  }
  //#endregion

  //#region - Set Filter data to get temp observation req which raised by mobile device
  //  check DESC Submit date data
  descSubmissionDate() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.SubmitDate;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.DESC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }

  //  check ASC Submit date data
  ascSubmissionDate() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.SubmitDate;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.ASC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }
  descIncidentId() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.IncidentId;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.DESC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }
  ascIncidentId() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.IncidentId;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.ASC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }
  descCaseOwner() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.CaseOwnerId;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.DESC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }
  ascCaseOwner() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.CaseOwnerId;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.ASC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }
  descLocation() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.LocationId;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.DESC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }
  ascLocation() {
    this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.LocationId;
    this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.ASC;
    this.searchModified = true;
    // Get Incident Request for specifc user id
    this.getIncidentRequestByUserId();
  }
  resetValue() {
    this.incidentFilterData = new DashboardFilter();
    this.defaultStatus = 'New';
    this.filterList = [];
    this.filterList.push(this.defaultStatus);
    this.pageSize = 1;
    this.incidentFilterData.CaseOwner = new User();
    this.isHighPotential = "false";
    this.selectedPotential = [];
    this.selectedUnit = [];
    this.selectedPotential.push(0);
    this.selectedPotential.push(1);
    this.searchModified = true;
    // Get Pending Status Id
    this.getIncidentRequestByUserId();
    this.incidentService.setAllIncidentIds([]);
  }
  //#endregion


  //#region - Get Incident requets for specific user
  getIncidentRequestByUserId() {
    if(this.RedirectFromDashboard == 1)
    {
      this.reset();
      const filter = JSON.parse(this.baseService.getFilterData('dashboardFilter'));
      if(filter)
      {
        this.incidentFromDate = new Date(filter.Model.FromDateForOverview);
        this.incidentToDate = new Date(filter.Model.ToDateForOverview);
      }
    }
    this.baseService.showRootLoader = true;
    if (!this.incidentFilterData.OrderdByColoumName) {
      this.incidentFilterData.OrderdByColoumName = IncidentConstantsService.DasboardFilter.SubmitDate;
    }
    if (!this.incidentFilterData.OrderdBy) {
      this.incidentFilterData.OrderdBy = IncidentConstantsService.DasboardFilter.DESC;
    }
    if (!this.rowCount) {
      this.rowCount = this.itemPerPage * 2;
    }
    if (this.statusId.length === 0) {
      this.statusList.forEach((item) => {
        item.checked = true;
        this.statusId.push(item.value);
      });
    }
    if (!this.selectedUnit.length) {
      this.unitList.forEach(element => {
        element.checked = true;
        this.selectedUnit.push(element.value);
      });
    }
    if (!this.selectedincidentTypeId.length) {
      this.incidentTypeList.forEach(element => {
        element.checked = true;
        this.selectedincidentTypeId.push(element.value);
      });
    }
    if (!this.selectedReportedTo.length) {
      this.reportedToList.forEach(element => {
        element.checked = true;
        this.selectedReportedTo.push(element.value);
      });
    }
    this.incidentFilterData.Units = this.selectedUnit;
    this.incidentFilterData.CurrentPage = this.pageSize;
    this.incidentFilterData.PageSize = this.itemPerPage;
    this.incidentFilterData.IncidentFromDate = this.incidentFromDate !== null ? new Date(this.incidentFromDate.setHours(0, 0, 0, 0)) : this.incidentFromDate;
    this.incidentFilterData.IncidentToDate = this.incidentToDate !== null ? new Date(this.incidentToDate.setHours(23, 59, 59, 0)) : this.incidentToDate;
    this.incidentFilterData.StatusId = this.statusId;
    this.incidentFilterData.RaisedBy = this.loggedInUserJSON.UserId;
    this.incidentFilterData.CaseOwnerId = this.loggedInUserJSON.UserId;
    this.incidentFilterData.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    
    this.incidentFilterData.UserId = this.loggedInUserJSON.UserId;
    this.incidentFilterData.UnitId = 0;
    this.incidentFilterData.SearchText = this.searchText;
    this.incidentFilterData.SelectAll = this.isIncidentsChecked;
    if (this.incidentFilterData.CaseOwner && this.incidentFilterData.CaseOwner.UserId > 0) {
      this.incidentFilterData.CaseOwnerId = this.incidentFilterData.CaseOwner.UserId;
    } else {
      this.incidentFilterData.CaseOwnerId = 0;
    }
    if (this.selectedLocations.length === 0) {
      this.locationList.forEach(location => {
        this.selectedLocations.push(location.value);
      });
    }
    this.incidentFilterData.Locations = this.selectedLocations;
    this.incidentFilterData.HighPotential = this.selectedPotential;
    this.incidentFilterData.IncidentRating = this.incidentRating;
    this.incidentFilterData.IncidentType = this.selectedincidentTypeId;
    this.incidentFilterData.ReportedTo = this.selectedReportedTo;
    const filter = JSON.parse(this.baseService.getFilterData('incidentFilter'));
    if (!this.searchModified && filter) {
      this.incidentFilterData = filter;
      this.incidentFromDate = filter.IncidentFromDate === null ? filter.IncidentFromDate : new Date(filter.IncidentFromDate);
      this.incidentToDate = filter.IncidentToDate === null ? filter.IncidentToDate : new Date(filter.IncidentToDate);
      this.statusId = filter.StatusId;
      this.isIncidentsChecked = filter.SelectAll;
      this.selectedincidentTypeId = filter.IncidentType;
      if (filter.IncidentRating)
        this.incidentRating = filter.IncidentRating;
      else
        this.incidentRating = new IncidentRating();
      this.selectedReportedTo = filter.ReportedTo;
      if (!this.incidentService.getAllIncidentIds()) {
        this.isIncidentsChecked = true;
        this.incidentFilterData.SelectAll = true;
      }
      this.statusList.forEach(status => {
        status.checked = false;
      });
      this.statusList.forEach(status => {
        this.statusId.forEach(element => {
          if (status.StatusId === element) {
            status.checked = true;
          }
        });
      });
      this.pageSize = parseInt(filter.CurrentPage);
      if (this.pageSize === 1) {
        this.incidentFilterData.PageIndex = 0;
      } else {
        this.incidentFilterData.PageIndex = ((this.pageSize * this.itemPerPage) - this.itemPerPage);
        this.rowCount = ((this.pageSize + 1) * this.itemPerPage);
      }
      this.actionTypeId = filter.IncidentType;
      this.searchText = filter.SearchText;
      this.caseOwner = filter.CaseOwnerId;
      this.selectedPotential = filter.HighPotential;
      this.selectedUnit = filter.Units;
    } else {
      this.baseService.setFilterData('incidentFilter', JSON.stringify(this.incidentFilterData));
    }
    this.incidentFilterData.UserId = this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: this.incidentFilterData
    };
    this.incidentService.getIncidentRequestByUserId(apiRequest, this.callbackMethodForGetIncidentRequestByUserId.bind(this));
  }
  getAllIncidentIds() {
    const filter = JSON.parse(this.baseService.getFilterData('incidentFilter'));
    filter.PageIndex = 0;
    filter.PageSize = 10000;
    const apiRequest = {
      Model: filter
    };
    this.incidentService.getIncidentRequestByUserId(apiRequest, this.callbackMethodForgetAllIncidentIds.bind(this));
  }
  callbackMethodForgetAllIncidentIds(response) {
    this.incidentService.setAllIncidentIds(response.Result);
  }
  callbackMethodForGetIncidentRequestByUserId(response) {
    this.baseService.showRootLoader = false;
    if (response && response.Success) {
       //BOC Pritesh
       if(response.Result.length > 0)
       {
       response.Result.forEach((element,index) => {
         if(element.Status ==='Draft' && element.CreatedBy !== this.loggedInUserJSON.UserId)  
         {
           response.Result.splice(index,1);
         }
       });
       }
        //EOC Pritesh
      this.incidentRequestData = response.Result;
      if (response.Result.length < this.itemPerPage) {
        this.rowCount = this.rowCount - this.itemPerPage;
      }
      if (this.incidentFilterData.SelectAll && !this.searchModified) {
        this.selectAllIncidents(this.incidentFilterData.SelectAll);
      } else if (this.searchModified) {
        this.incidentFilterData.SelectAll = true;
        this.isIncidentsChecked = true;
        this.incidentService.setAllIncidentIds([]);
        this.selectAllIncidents(this.incidentFilterData.SelectAll);
      } else {
        if (this.incidentService.getAllIncidentIds()) {
          this.incidentRequestData.forEach(element => {
            this.incidentService.getAllIncidentIds().forEach(stored => {
              if (element.IncidentRequestId === stored) {
                element.Checked = true;
              }
            });
          });
        }
      }
    } else {
      this.baseService.processApiResponseError(response);
    }
  }
  //#endregion

  // Hide and show the filter click on outside
  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }

  // Hide and show the filter based on tab selection
  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }

  // Method to call when next page is loaded
  getServerData(event) {
    if (event === 1) {
      this.incidentFilterData.PageIndex = 0;
    } else {
      this.incidentFilterData.PageIndex = ((event * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((event + 1) * this.itemPerPage);
    }
    this.pageSize = event;
    // Get Temp Obseravation Request for file upload by mobile user
    this.searchModified = true;
    this.getIncidentRequestByUserId();
  }
  //#endregion

  ngOnInit() {
    this.baseService.showRootLoader = true;
    this.contextItems = [
      {
        label: 'Open In New Tab',
        icon: 'fa-external-link-square',
        command: e => this.openAction()
      }];
    this.incidentRequestData = [];
    this.statusList = [];
    this.filterList = [];
    this.defaultStatus = 'New';
    this.filterList.push(this.defaultStatus);
    // Set value for tab show and hide
    this.hideFilter = true;
    this.hideSort = true;
    // Set routeURL and route name
    const routes = JSON.stringify(IncidentConstantsService.IncidentNavigation.Routes);
    this.routesFlag = JSON.parse(routes);
    this.route.params.subscribe(params => {
      this.RedirectFromDashboard = isNaN(params["D"])? 0 :coerceNumberProperty(params["D"]);
    });
    this.reportRoutes = IncidentConstantsService.IncidentNavigation.ReportRoutes;
    this.incidentPermission = new IndependentPermissions();
    this.userPermissions = new UserPermissionParameters();
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.commonService.getUserIndependentPermissions(this.loggedInUserJSON.UserId);
    // Set Hide/Display logic for case owner
    this.routesFlag = this.incidentService.checkRouteForCaseOwner(this.routesFlag);
    // Get List of Status by process name
    this.getStatusListByProcessName();
    this.actionTypeId = 1;
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });

  }
  changeActionType($event, actionType, actionTypeId) {
    this.actionType = actionType;
    this.actionTypeId = actionTypeId;
    this.searchModified = true;
    switch (actionType) {
      case "MyIncidents":
        this.showcaseOwner = false;
        this.isshowBackOffice = false;
        this.getIncidentRequestByUserId();
        break;
      case "CaseOwner":
        this.showcaseOwner = true;
        this.isshowBackOffice = false;
        this.getIncidentRequestByUserId();
        break;
      case "All":
        this.showcaseOwner = false;
        this.isshowBackOffice = false;
        this.getIncidentRequestByUserId();
        break;
      case "BackOffice":
        this.isshowBackOffice = true;
        this.showcaseOwner = false;
        this.getIncidentRequestByUserId();
        break;
    }
  }
  exportToExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const filter = JSON.parse(this.baseService.getFilterData('incidentFilter'));
    filter.SourceIds = this.incidentService.getAllIncidentIds();
    const apiRequest = {
      Model: filter
    };
    // Call To Get Incident requests for specific user id
    this.incidentService.getExportToExcelIncidentRequestByUserId(apiRequest, this.callbackMethodForGetExportToExcelIncidentRequestByUserId.bind(this));
  }
  callbackMethodForGetExportToExcelIncidentRequestByUserId(response) {

    if (response.Success) {
      const exportData = response.Result;
      
      response.Result.forEach(element => {
        if (element.IsHighPotential === true) {
          element.showHighPotential = 'Yes';
        } else {
          element.showHighPotential = 'No';
        }
      });
      const columnList = [
        { key: "IncidentRequestId", value: "ID" },
        { key: "showHighPotential", value: "High Potential" },
        { key: "ActivityTakingAtIncident", value: "Activity Taking Place At Incident" },
        { key: "DetailDescription", value: "Detail Description" },
        { key: "ImmediateCause", value: "Immediate Cause" },
        { key: "IncidentDate", value: "Date" },
        { key: "InitalFact", value: "Inital Fact" },
        { key: "ShortDescription", value: "Short Description" },
        { key: "IncidentDocuments", value: "Incident Documents" },
        { key: "UnitName", value: "Unit" },
        { key: "IncidentTypes", value: "Incident Types" },
        { key: "CaseOwner.FullName", value: "CaseOwner" },
        { key: "ContractNumber", value: "Contract Number" },
        { key: "Status", value: "Status" },
        { key: "ContractHolderName", value: "Contract Holder Name" },
        { key: "ContractNumber", value: "Contract Number" },
        { key: "ClosedActions", value: "ClosedActions" },
        
      ];
      const parsedResponse: any = FileUtility.convertToCSV(exportData, columnList);
      FileUtility.downloadCSV(parsedResponse, 'IncidentReport.csv');
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  doneFilter() {
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    this.searchModified = true;
    this.getIncidentRequestByUserId();
    this.incidentService.setAllIncidentIds([]);
    this.hideFilter = false;
  }

  reset()
  {
    this.incidentFromDate = null;
    this.incidentToDate = null;
    this.actionTypeId = 1;
    this.statusId = [];
    this.selectedincidentTypeId = [];
    this.selectedReportedTo = [];
    this.incidentRating = new IncidentRating();
    this.isHighPotential = "false";
    this.selectedPotential = [];
    this.selectedUnit = [];
    this.selectedPotential.push(1);
    this.selectedPotential.push(0);
    this.incidentFilterData.CaseOwner = new User();
    this.searchModified = true;
    this.RedirectFromDashboard = 0;
  }

  resetFilter() {
    this.reset();
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    this.getIncidentRequestByUserId();
    this.onClickedOutside();
  }
  highlightCurrentSelectedIncident(id) {
    var el = document.getElementById(id);
    while (!this.checked && el !== null) {
      this.checked = true;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      let currentColor = document.getElementById(id).style.backgroundColor;
      if (currentColor !== null && currentColor !== 'darkgray') {
        document.getElementById(id).style.backgroundColor = 'darkgray';
      }
      el = null;
    }
  }
  getCurrentDOMElementId(id) {
    this.incidentService.setcurrentIncidentRequestId(id);
    let incidents = this.incidentService.getAllIncidentIds();
    this.incidentRequestData=this.incidentRequestData;

    if (!incidents) {
      incidents = [];
    }
    this.incidentRequestData.forEach(element => {
      if (element.IncidentRequestId === id) {
       // incidents.push(element);
        return;
      }
    });
    this.incidentService.setAllIncidentIds(incidents);
    this.router.navigate(['/incident/report-incident/' + id]);
  }
  ngAfterViewChecked() {
    let currentIncidentRequestId = this.incidentService.getcurrentIncidentRequestId();
    if (currentIncidentRequestId !== '') {
      this.highlightCurrentSelectedIncident(currentIncidentRequestId);
    }
  }
  getUsersOnSearch(event) {
    this.searchTexts = new SearchText();
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.actionTrackerService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));
  }
  // call back method of employee on search
  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response.Success) {
      const filtered: any[] = [];
      for (let index = 0; index < response.Result.length; index++) {
        const user = response.Result[index];
        if (
          user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(user);
        }
      }
      this.userResults = filtered;
    }
  }
  selectCaseOwner(event) {
    this.searchModified = true;
    if (!event.UserId) {
      this.caseOwner = null;
      this.incidentFilterData.CaseOwnerId = 0;
    }
  }
  getLocations() {
    const login = new Login();
    login.CompanyId = 0;
    const apiRequest = {
      Model: login
    };
    this.observationService.getLocationData(apiRequest, this.callbackMethodForGetLocationData.bind(this));
  }
  callbackMethodForGetLocationData(response) {
    if (response.Success) {
      this.locationList = [];
      response.Result.forEach((location) => {
        location['checked'] = true;
        this.locationList.push(
          {
            'label': location.LocationName,
            'value': location.LocationId,
          }
        );
      });
    }
    this.getUnits();
  }

  getIncidentTypes() {


  }
  searchData() {
    this.searchModified = true;
    this.getIncidentRequestByUserId();
    this.incidentService.setAllIncidentIds([]);
  }
  clearSearch() {
    this.searchModified = true;
    this.searchText = '';
    if (this.searchText !== this.incidentFilterData.SearchText) {
      this.getIncidentRequestByUserId();
      this.incidentService.setAllIncidentIds([]);
    }
  }
  showContextMenu(incident) {
    this.selectedIncident = incident.IncidentRequestId;
  }
  openAction() {
    window.open('/incident/report-incident/' + this.selectedIncident, '_blank')
    this.contextMenu.hide();
  }
  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    this.incidentSourceIdsDetails = [];
    this.incidentService.getAllIncidentIds().forEach(element => {
      this.incidentSourceIdsDetails.push({
        ProcessName: 'Incident',
        SourceId: element,
        UserId: this.loggedInUserJSON.UserId
      });
    });
    if (this.incidentSourceIdsDetails.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: this.incidentSourceIdsDetails
        }
      }
      this.incidentService.downloadZIP(apiRequest, this.callbackMethodForDownloadZIP.bind(this));
    }
  }
  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_incident.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
  selectIncidents(incidentRequest, event) {
    let incidents = this.incidentService.getAllIncidentIds();
    if (event.target.checked) {
      incidents.push(incidentRequest.IncidentRequestId);
      if (incidents.length === this.incidentRequestData.length) {
        this.isIncidentsChecked = true;
      }
    } else {
      this.isIncidentsChecked = false;
      this.incidentFilterData.SelectAll = this.isIncidentsChecked;
      for (let index = 0; index < incidents.length; index++) {
        const element = incidents[index];
        if (incidentRequest.IncidentRequestId === element) {
          incidents.splice(index, 1);
          break;
        }
      }
    }
    this.incidentService.setAllIncidentIds(incidents);
    this.baseService.setFilterData('incidentFilter', JSON.stringify(this.incidentFilterData));
  }
  selectAllIncidents(checked) {
    let selectedIncidents = [];
    this.incidentRequestData.forEach(element => {
      if (checked) {
        element.Checked = true;
       // selectedIncidents = this.incidentService.getAllIncidentIds();
        if (!selectedIncidents) {
          selectedIncidents = [];
        }
        selectedIncidents.push(element.IncidentRequestId);
        this.incidentService.setAllIncidentIds(selectedIncidents);
      } else {
        element.Checked = false;
        this.incidentService.setAllIncidentIds([]);
      }
    });
    this.incidentFilterData.SelectAll = this.isIncidentsChecked;
    this.baseService.setFilterData('incidentFilter', JSON.stringify(this.incidentFilterData));
  }
  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      }
    }
     
    this.masterscreenService.getUnits(apiRequestUnit, this.callbackMethodForUnitDetails.bind(this));
  }
  callbackMethodForUnitDetails(response) {

    if (response.Success) {
       
      const unitDetails = response.Result;
      this.unitList = [];
      this.selectedUnit = [];
      unitDetails.forEach((unit) => {
        this.unitList.push(
          {
            'label': unit.UnitName,
            'value': unit.UnitId,
            'checked': true
          }
        );
        this.selectedUnit.push(unit.UnitId);
      });
    }
    this.getIncidentTypeByCompanyId();
  }

  downloadPDF(IncidentRequestId) {
    this.currentId = IncidentRequestId;
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "Incident",
        SourceId: IncidentRequestId
      }
    };
    this.incidentService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }

  callbackMethodForDownloadPDF(response) {
    var data = response;
    //Here assign the Byte array returned from API to data variable
    var fileDownLoadName = "pdf_incidentrequest" + this.currentId + ".pdf"; //Here we can assign name of the document
    FileUtility.downloadPDF(response, fileDownLoadName);
  }
  getIncidentTypeByCompanyId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CompanyId: 2
      }
    };
    // Get all observation type data
    this.incidentService.getIncidentTypeByCompanyId(
      apiRequest,
      this.callbackMethodForGetIncidentTypeDetails.bind(this)
    );
  }

  /**
   * Callback method of observation type details.
   * @param response - response of request.
   */
  callbackMethodForGetIncidentTypeDetails(response) {
    if (response && response.Success) {
      this.incidentTypeList = [];
      response.Result.forEach(e => {
        this.incidentTypeList.push({ label: e.IncidentType, value: e.IncidentTypeId, checked: true });
        this.selectedincidentTypeId.push(e.IncidentTypeId);
      })
    } else {
      this.baseService.showRootLoader = false;
      this.baseService.processApiResponseError(response);
    }
    this.getIncidentRequestByUserId();
  }

  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }
}
